// InfoHint — chấm ⓘ nhỏ, hiện giải thích ngắn khi hover/focus (hover + bàn phím +
// chạm đều mở qua focus). Dùng làm rõ thuật ngữ phương pháp luận (MIT, sức chứa,
// PARA) cho người mới, không chiếm chỗ trên giao diện.
import { Info } from "lucide-react";

export function InfoHint({ text, label = "Giải thích" }: { text: string; label?: string }) {
  return (
    <span className="group relative inline-flex align-middle">
      <button
        type="button"
        aria-label={label}
        className="grid place-items-center text-ink-400 transition hover:text-brand-600 focus:text-brand-600 focus:outline-none"
        onClick={(e) => e.stopPropagation()}
      >
        <Info className="h-3.5 w-3.5" />
      </button>
      <span
        role="tooltip"
        className="pointer-events-none absolute left-1/2 top-full z-[70] mt-1.5 w-52 -translate-x-1/2 rounded-xl bg-ink-900 px-3 py-2 text-[11px] font-medium leading-snug text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100 dark:bg-ink-700"
      >
        {text}
      </span>
    </span>
  );
}
